import App from './index.svelte';

const target = document.body;

const app = new App({
  target,
});

export default app;
